import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { GroupRounded } from '@mui/icons-material';

type ActionResponse = Array<{
    id: string;
    name: string;
    dashSource: {
        id: string;
        nameKey: string;
        code: string;
        group: string;
    } | null;
    username?: string | null;
    picture?: string | null;
    status: string;
}>;

export type AndieGetWidgetsAvailableProfilesProps = ActionRenderAi<ActionResponse>;

const AndieGetWidgetsAvailableProfiles = (props: AndieGetWidgetsAvailableProfilesProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.get-widgets-available-profiles.title')}
            icon={<GroupRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-widgets-available-profiles.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-widgets-available-profiles.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetWidgetsAvailableProfiles;
